// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'hexagons';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M6.737 3.695 9.98 5.567v3.745l-3.243 1.873-3.243-1.873V5.567zm6.503 0 3.244 1.872v3.745l-3.244 1.873-3.243-1.873V5.567zm-.024.018V1.086m1.436 7.174V6.447m-4.32 8.338L8.66 13.713M6.853 8.987l1.387-.784m-1.485 6.764-3.122 1.947M3.54 5.6 1.128 4.362M13.37 14.936l2.721 1.762' />
    <path d='m9.989 9.274 3.243 1.872v3.745l-3.243 1.873-3.244-1.873v-3.745z' />
  </g>
);

export const viewBox = '0 0 18 18';
